function updateCart(formData) {
  return fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
  .then((response) => {
    console.log('response', response);
    return true;
  })
  .catch((error) => {
    console.error("Error:", error);
    return false;
  });
}

function syncCartNote(element) {
  const cartFormInput = document.querySelector("[data-cart-note-form]");
  if (cartFormInput) {
    cartFormInput.value = element.value;
  }
}

function addCartNote() {
  const cartNote = document.querySelector('textarea[name="note"][data-cart-note]');
  if (cartNote) {
    updateCart({ note: cartNote.value });
  }
}

function addNoteOnClickViewCart(event) {
  const goToCart = document.querySelector("[data-action-go-cart]");
  const cartNote = document.querySelector('textarea[name="note"][data-cart-note]');

  if (goToCart && cartNote) {
    event.preventDefault();
    const href = event.target.getAttribute("href");
    if (href === "/cart") {
      const formData = { note: cartNote.value };
      updateCart(formData)
        .then((result) => {
          if (result === true) {
            window.location.href = href;
          }
        })
        .catch((error) => {
          console.error("Error updating the cart:", error);
        });
    }
    return false;
  }
}